const messages = {
  title: "Cenniki i broszury produktowe",
  description:
    "Pobierz tutaj najnowsze broszury i ulotki dotyczące opon Bridgestone i Firestone do samochodów osobowych, SUV-ów i dostawczych.",
  brochureCategories: {
    products: "Produkty",
    brand_and_solutions: "Marka i rozwiązania",
    season_and_promotions: "Sezon i promocje",
    format: "Format",
    cars_and_vans: "Samochody osobowe i dostawcze",
    summer: "Lato",
    winter: "Zima",
    promotions: "Promocje",
    all_season: "Całoroczne",
    truck_and_buses: "Ciężarowe i autobusy",
    motorcycle: "Motocykle",
    agriculture: "Rolnictwo",
    construction_machinery: "Maszyny budowlane",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiały",
    brochures: "Broszury produktowe",
    price_list: "Cenniki",
    materials: "Materiały",
    video_in_store: "Wideo z napisami",
    video_online: "Wideo bez napisów",
    banner_website: "Baner",
    banner_social_media: "Media społecznościowe",
    logos: "Logos",
  },
  searchMedia: "Wpisz słowo kluczowe",
  searchResults: "Wyniki wyszukiwania",
};

export default {
  messages,
};
